export default __webpack_public_path__ + "static/media/five.35a0cbdb.svg";